import { FC, useEffect, useRef, useState } from "react"

import { useProduct } from "../../hooks/useProduct";
import styles from './index.module.css'
import { useNavigate, useParams } from "react-router-dom";
import { TwoThumbInputRange } from "react-two-thumb-input-range";
import { FilterProductOptions } from "../../contexts/ProductsContext";
import { IoClose } from "react-icons/io5";
import { Loading } from "../Loading";
import IntlCurrencyInput from 'react-intl-currency-input'
import 'animate.css'
import './filtroproduto.css'
import { useCategory } from "../../hooks/useCategory";
import { AccessButton } from "../EmptyStates/EmptyState";
import { floatToPrice } from "../../functions/price_functions";

import { useAppConfig } from "../../hooks/useAppConfig";
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';

type props = {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;

}

const FiltroPdvModal: FC<any> = () => {

    const { openModalFiltroPDV, setOpenModalFiltroPDV, saveCurrentCategoryFilter, getCurrentCategoryFilter } = useProduct()
    const { getAppConfig } = useAppConfig()
    const navigate = useNavigate()
    const { pluginspace_id, category_id, id_catalog } = useParams();
    const { getChildrenCategories } = useCategory();
    const { getFilterProductOptions, saveFilterProductOptions, getGrades, getGradesByCatalog } = useProduct()
    const [filterOptions, setFilterOptions] = useState<FilterProductOptions>({
        prices: { min: 0, max: 0 },
        name: '',
        categories: [],
    })
    const [loading, setLoading] = useState(false);
    const [grades, setGrades] = useState<{
        field: string;
        values: string[];
    }[]>([])
    const [priceRange, setPriceRange] = useState<[number, number]>([0, 5000])

    const [minRange, setMinRange] = useState<number>(0)
    const [maxRange, setMaxRange] = useState<number>(5000)

    /*Usado para ordernar a lista de tamanhos */

    const [myOrdenationVariation, setMyOrdenationVariation] = useState([
        "PP",
        "XS",
        "P",
        "S",
        "M",
        "G",
        "L",
        "2G",
        "GG",
        "LL",
        "XL",
        "3G",
        "3L",
        "XXL",
        "XGG",
        "1X",
        "2X",
        "3X",
        "3L",
        "4X",
        "4L",
        "0-3 meses",
        "3-6 meses",
        "6-9 meses",
        "9-12 meses",
    ]);

    const refDiv = useRef<HTMLDivElement>(null)

    const onValueChange = (values: [number, number]) => {
        console.log('values', values)
        setPriceRange(values)
    }

    async function loadGrades(categorias_id: string[], name?: string) {
        setLoading(true);
        const filterOptions = await getFilterProductOptions()

        const currentCategoryFilter = getCurrentCategoryFilter();

        if (JSON.stringify(categorias_id) !== currentCategoryFilter) {
            Object.keys(filterOptions).forEach((key) => {
                if (key !== "categories" && Array.isArray(filterOptions[key as keyof FilterProductOptions])) {
                    filterOptions[key as keyof FilterProductOptions] = [];
                }
            });

            saveCurrentCategoryFilter(JSON.stringify(categorias_id));
        }



        if (name) {
            filterOptions.name = name
        } else {
            filterOptions.name = ''
        }

        setFilterOptions(filterOptions)
        setPriceRange([filterOptions.prices.min, filterOptions.prices.max])
        const app = await getAppConfig()
        const noStock = app?.content.pdv.showOutStock ?? false

        const response = await getGrades(categorias_id, noStock, name);

        if (response.find(t => t.field === 'priceRange')) {
            const priceRange: any = response.find(t => t.field === 'priceRange')
            if (priceRange) {
                setPriceRange([
                    Math.min(priceRange.values.min, priceRange.values.max),
                    Math.max(priceRange.values.min, priceRange.values.max + 1)
                ]);
                setMaxRange(priceRange.values.max + 1)
                setMinRange(priceRange.values.min)
            }
        }


        setGrades(response);
        setLoading(false);
    }

    async function loadGradesByCatalog(catalog_id: string, name?: string) {
        setLoading(true);
        const filterOptions = await getFilterProductOptions()
        filterOptions.name = ''

        Object.keys(filterOptions).forEach((key) => {
            if (key !== "categories" && Array.isArray(filterOptions[key as keyof FilterProductOptions])) {
                filterOptions[key as keyof FilterProductOptions] = [];
            }
        });

        if (name) {
            filterOptions.name = name
        } else {
            filterOptions.name = ''
        }

        setFilterOptions(filterOptions)
        setPriceRange([filterOptions.prices.min, filterOptions.prices.max])

        const app = await getAppConfig()

        const noStock = app?.content.pdv.showOutStock ?? false

        const response = await getGradesByCatalog(catalog_id, noStock);

        if (response.find(t => t.field === 'priceRange')) {
            const priceRange: any = response.find(t => t.field === 'priceRange')
            if (priceRange) {
                setPriceRange([
                    Math.min(priceRange.values.min, priceRange.values.max),
                    Math.max(priceRange.values.min, priceRange.values.max + 1)
                ]);
                setMaxRange(priceRange.values.max + 1)
                setMinRange(priceRange.values.min)
            }
        }


        setGrades(response);
        setLoading(false);
    }



    async function salvarFiltro() {
        try {
            const subcategories = await getChildrenCategories(category_id!);
            const subcategoriesIds = subcategories.map((item: any) => item.id)
            const newFilterOptions = { ...filterOptions };
            newFilterOptions.prices = {
                min: priceRange[0],
                max: priceRange[1]
            };

            const filtro = await getFilterProductOptions()

            const currentPath = window.location.pathname;
            if (!currentPath.includes(`/${pluginspace_id}/pdv/filtro`)) {
                newFilterOptions.name = ''
            } else {
                newFilterOptions.name = filtro.name ? filtro.name : ''
            }



            newFilterOptions.categories = subcategoriesIds
            saveFilterProductOptions(newFilterOptions);
            setOpenModalFiltroPDV(false)

            if (id_catalog) {
                navigate(`/${pluginspace_id}/catalog/${id_catalog}?refresh=${new Date().getTime()}`, { replace: true });
                setOpenModalFiltroPDV(false)
                return
            }

            if (currentPath.includes(`/${pluginspace_id}/pdv/filtro`)) {

                navigate(`/${pluginspace_id}/pdv/filtro?refresh=${new Date().getTime()}`, { replace: true });
            } else {
                navigate(`/${pluginspace_id}/pdv/${category_id}/filtro?refresh=${new Date().getTime()}`, { replace: true });

            }

        } catch (error) {
            console.error("Error saving filter options:", error);
        }
    }

    async function clearFiltro() {
        try {
            const subcategories = await getChildrenCategories(category_id!);
            const subcategoriesIds = subcategories.map((item: any) => item.id)

            const newFilterOptions: FilterProductOptions = {
                prices: {
                    min: minRange,
                    max: maxRange
                },
                name: '',
                categories: subcategoriesIds,
            };

            const filtro = await getFilterProductOptions()

            const currentPath = window.location.pathname;
            if (!currentPath.includes(`/${pluginspace_id}/pdv/filtro`)) {
                newFilterOptions.name = ''
            } else {
                newFilterOptions.name = filtro.name ? filtro.name : ''
            }


            Object.keys(filterOptions).forEach((key) => {
                if (key !== "categories" && Array.isArray(filterOptions[key as keyof FilterProductOptions])) {
                    newFilterOptions[key as keyof FilterProductOptions] = [];
                }
            });
            setPriceRange([minRange, maxRange])
            saveFilterProductOptions(newFilterOptions);
            setFilterOptions(newFilterOptions);

            if (id_catalog) {
                navigate(`/${pluginspace_id}/catalog/${id_catalog}?refresh=${new Date().getTime()}`, { replace: true });
                setOpenModalFiltroPDV(false)
                return
            }


            if (currentPath.includes(`/${pluginspace_id}/pdv/filtro`)) {
                navigate(`/${pluginspace_id}/pdv/filtro?refresh=${new Date().getTime()}`, { replace: true });
            } else {
                navigate(`/${pluginspace_id}/pdv/${category_id}/filtro?refresh=${new Date().getTime()}`, { replace: true });
            }
            setOpenModalFiltroPDV(false)
        } catch (error) {
            console.error("Error saving filter options:", error);
        }
    }

    function changeFilterOptions(type: any | 'prices', value: any) {
        const newFilterOptions = { ...filterOptions };
        if (type === 'prices') {
            newFilterOptions.prices = value;
        } else {
            if (!newFilterOptions[type]) {
                newFilterOptions[type] = [value];
            } else {
                newFilterOptions[type] = newFilterOptions[type].includes(value) ?
                    newFilterOptions[type].filter((item: any) => item !== value) : [...newFilterOptions[type], value];
            }
        }
        setFilterOptions(newFilterOptions);
    }

    function findInFilterOptions(type: any | 'prices', value: any) {
        const newFilterOptions = { ...filterOptions };
        if (type === 'prices') {
            return newFilterOptions.prices;
        }
        if (newFilterOptions[type]) {
            return newFilterOptions[type].includes(value);
        }
        return false;
    }

    async function loadCategories(category_id: string) {
        const subcategories = await getChildrenCategories(category_id);
        const subcategoriesIds = subcategories.map((item: any) => item.id)

        const newFilterOptions = { ...filterOptions };
        newFilterOptions.categories = subcategoriesIds;
        setFilterOptions(newFilterOptions);
        await loadGrades(subcategoriesIds)

    }

    async function loadFilterOptions(category_id: string) {
        const subcategories = await getChildrenCategories(category_id);
        const subcategoriesIds = subcategories.map((item: any) => item.id)
        await loadGrades(subcategoriesIds)
    }

    async function loadFilterOptionsByCatalog(catalog_id: string) {

        await loadGradesByCatalog(catalog_id)
    }

    useEffect(() => {
        // Só executa se o pathname for exatamente igual a `/${pluginspace_id}/pdv/filtro`
        const fetchFilterAndLoadGrades = async () => {
            const currentPath = window.location.pathname;
            if (
                openModalFiltroPDV &&
                currentPath.includes(`/${pluginspace_id}/pdv/filtro`)
            ) {
                const filter = await getFilterProductOptions();
                loadGrades([], filter.name);
            }
        };
        fetchFilterAndLoadGrades();
    }, [openModalFiltroPDV]);

    useEffect(() => {
        if (category_id) {
            loadFilterOptions(category_id)
        }
    }, [category_id])

    useEffect(() => {
        if (refDiv.current) {

            refDiv.current.scrollTo({ top: 0, behavior: 'smooth' });
            //loadCategories(category_id ? category_id : '');
        }
    }, [openModalFiltroPDV])

    useEffect(() => {
        if (id_catalog) {
            loadFilterOptionsByCatalog(id_catalog)
        }
    }, [id_catalog])

    const [isAnimating, setIsAnimating] = useState(false);


    function handleCloseModal() {
        setIsAnimating(true); // Inicia a animação de fechamento
        setOpenModalFiltroPDV(false); // Fecha o modal
    }

    return (
        <>
            {(openModalFiltroPDV || isAnimating) && (
                <div className={styles.filtro_modal_container}>
                    <div
                        className={`
                    ${styles.filtro_modal}
                    
                    animate__animated ${openModalFiltroPDV ? `animate__fadeInUp ${styles.filtro_container_XA}` : 'animate__fadeOutDown'}
                    `}
                        onAnimationEnd={() => {
                            if (!openModalFiltroPDV) setIsAnimating(false); // Remove do DOM após a animação de fechamento
                        }}
                    >
                        <div className={styles.background_filtro} onClick={handleCloseModal}></div>
                        {loading ? (
                            <div style={{
                                width: '100%',
                                height: '100%',
                            }}>
                                <Loading
                                    type="spinningBubbles"
                                    color="#FFF"
                                    width={64}
                                    height={64}
                                />
                            </div>
                        ) : (
                            <div className={styles.filtro_container}>
                                <div className={styles.filtro_close_x_button}>

                                    <IoClose onClick={handleCloseModal} size={20} />

                                </div>
                                <div className={styles.filtro_conteudo_dados}

                                    ref={refDiv}
                                    onClick={(e) => e.stopPropagation()} // Prevent click propagation
                                >
                                    <div className={styles.filtro_conteudo}>
                                        <div className={styles.grade_filtro}>
                                            {grades.filter(t => t.field !== 'priceRange').map((typeGrid) => (
                                                <div key={typeGrid.field} className={styles.filter_option}>
                                                    <div className={styles.filter_option_container}>
                                                        <span className={styles.filter_option_title}>Filtrar por {typeGrid.field.charAt(0).toUpperCase() + typeGrid.field.slice(1).toLowerCase()}</span>
                                                        <div className={styles.variations}>
                                                            {typeGrid.values.sort((a, b) => {
                                                                if (typeGrid.field.toLowerCase() === 'tamanho') {
                                                                    const indexA = myOrdenationVariation.indexOf(a);
                                                                    const indexB = myOrdenationVariation.indexOf(b);
                                                                    if (indexA !== -1 && indexB !== -1) {
                                                                        return indexA - indexB;
                                                                    } else if (indexA !== -1) {
                                                                        return -1;
                                                                    } else if (indexB !== -1) {
                                                                        return 1;
                                                                    }
                                                                }
                                                                return a.localeCompare(b);
                                                            }).map((variation, index) => (
                                                                <span
                                                                    onClick={() => changeFilterOptions(typeGrid.field, variation)}
                                                                    key={index}
                                                                    className={`${styles.variation} ${findInFilterOptions(typeGrid.field, variation) ? styles.variation_selected : ''}`}>{variation}</span>
                                                            ))}
                                                        </div>
                                                    </div>


                                                </div>
                                            ))}


                                            <div className={styles.filter_money_option}>

                                                <span className={styles.filter_option_title}>Filtrar por Preço</span>
                                                <div className={styles.filter_money_option_input}>
                                                    {/* <TwoThumbInputRange
                                                    onChange={onValueChange}
                                                    values={[
                                                        Math.min(priceRange[0], priceRange[1]),
                                                        Math.max(priceRange[0], priceRange[1])
                                                    ]}
                                                    min={minRange}
                                                    max={maxRange}
                                                    showLabels={false}
                                                    railColor="rgba(234,233,236,1)"
                                                    thumbColor="rgba(133,133,133,1)"
                                                    trackColor="rgba(2,0,14,1)"
                                                    thumbStyle={{
                                                        height: '30px',
                                                        width: '30px',
                                                        borderRadius: '50%',
                                                        backgroundColor: 'rgba(133,133,133,1)',
                                                    }}
                                                    inputStyle={{
                                                        height: '7px',
                                                        width: window.innerWidth > 1024 ? 'calc(28rem - 5rem)' : 'calc(100vw - 5rem)',
                                                    }}
                                                />*/}

                                                    <RangeSlider
                                                        id="range-slider"
                                                        onInput={onValueChange}
                                                        value={[
                                                            Math.min(priceRange[0], priceRange[1]),
                                                            Math.max(priceRange[0], priceRange[1])
                                                        ]}
                                                        min={minRange}
                                                        max={maxRange}
                                                    />
                                                    <div style={{
                                                        position: "relative",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        marginTop: "16px",
                                                        width: "100%",

                                                        boxSizing: "border-box",

                                                    }}>
                                                        <span style={{

                                                            fontSize: "12px",
                                                            color: "#858585",
                                                            minWidth: "24px",
                                                            textAlign: "center",
                                                            pointerEvents: "none",
                                                        }}>{floatToPrice(Math.min(priceRange[0], priceRange[1]))}</span>
                                                        <span style={{

                                                            fontSize: "12px",
                                                            color: "#858585",
                                                            minWidth: "24px",
                                                            textAlign: "center",
                                                            pointerEvents: "none",
                                                        }}>{floatToPrice(Math.max(priceRange[0], priceRange[1]))}</span>
                                                    </div>
                                                </div>
                                                <div className={styles.filter_money_option_input_inputs_money}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "start",
                                                        }}>
                                                        <IntlCurrencyInput
                                                            className={styles.input_min}
                                                            currency={'BRL'}
                                                            config={{
                                                                locale: "pt-BR",
                                                                formats: {
                                                                    number: {
                                                                        BRL: {
                                                                            style: "currency",
                                                                            currency: "BRL",
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2,
                                                                        },
                                                                    },
                                                                },
                                                            }}
                                                            max={Math.max(priceRange[0], priceRange[1])}
                                                            min={Math.min(priceRange[0], priceRange[1])}
                                                            onChange={(event: any, value: number, maskedValue: string) => {

                                                                if (value < Math.min(priceRange[0], priceRange[1])) {
                                                                    value = Math.min(priceRange[0], priceRange[1])
                                                                }
                                                                onValueChange([value, Math.max(priceRange[0], priceRange[1])])


                                                            }}
                                                            value={Math.min(priceRange[0], priceRange[1])}

                                                        />
                                                    </div>
                                                    <div style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "end",
                                                    }}>
                                                        <IntlCurrencyInput
                                                            className={styles.input_max}
                                                            currency={'BRL'}
                                                            config={{
                                                                locale: "pt-BR",
                                                                formats: {
                                                                    number: {
                                                                        BRL: {
                                                                            style: "currency",
                                                                            currency: "BRL",
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2,
                                                                        },
                                                                    },
                                                                },
                                                            }}
                                                            max={Math.max(priceRange[0], priceRange[1])}
                                                            min={Math.min(priceRange[0], priceRange[1])}
                                                            onChange={(event: any, value: number, maskedValue: string) => {

                                                                if (value > Math.max(priceRange[0], priceRange[1])) {
                                                                    value = Math.max(priceRange[0], priceRange[1])
                                                                }
                                                                onValueChange([Math.min(priceRange[0], priceRange[1]), value])


                                                            }}
                                                            value={Math.max(priceRange[0], priceRange[1])}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className={styles.buttons_filtro}>
                                            <AccessButton
                                                text={'Limpar Filtro'}
                                                onClick={clearFiltro}
                                                outLine={true}
                                                growth={true}
                                            />

                                            <AccessButton
                                                text={'Filtrar'}
                                                onClick={salvarFiltro}
                                                growth={true} />
                                        </div>
                                    </div>
                                </div>


                            </div>
                        )}
                    </div>
                </div>
            )}</>
    )
}

export { FiltroPdvModal }